import React, {Component} from 'react';
import $ from 'jquery';
import {
    AJAX,
    show_popup,
    close_popup,
    compressImage,
    showPreloader,
    hidePreloader,
    device_inform,
    addStepLog,
    setUrlSinglePageApp
} from "../functions";
import TextContent from "../common/TextContent";
import {Redirect, withRouter} from "react-router";
import {Link} from "react-router-dom";
import {showProgressBarPopup} from '../popups/ProgressBarPopup';
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import PreviewPhoto from "../common/PreviewPhoto";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";


const steps = {
    'unlock': {
        'selfie': {next: 'license'},
        'license': {next: 'driver'},
        'driver': {next: 'rear'},
        'rear': {next: 'passenger'},
        'passenger': {next: 'front'},
        'front': {next: 'complete'},
    },
    'lock': {
        'dashboard': {next: 'driver'},
        'driver': {next: 'rear'},
        'rear': {next: 'passenger'},
        'passenger': {next: 'front'},
        'front': {next: 'cargo'},
        'cargo': {next: 'complete'},
    }
};

class ShowPopupExampleSelfie extends Component {
    constructor(props) {
        super(props);
    }

    goBack() {
        close_popup();
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="row m-3">
                        <div className="col-12 text-center">
                            <div className="example_selfie" />
                            {/*<img className="example_selfie" src={bm_domain+'/wp-content/plugins/booking-manage/css/images/example_selfie.jpg'} alt=""/>*/}
                        </div>
                    </div>
                    <div className="row mx-3 mb-3">
                        <div className="go-btn go-back mx-auto" onClick={this.goBack.bind(this)} />
                    </div>
                </div>
            </div>
        )
    }
}

class ShowPopupQuestionAboutAdditPhoto extends Component {
    constructor(props) {
        super(props);
    }

    yes() {
        close_popup();
        this.props.yes();
    }

    no() {
        close_popup();
        this.props.no();
    }

    render() {
        return (
            <div className="row pt-2">
                <div className="col-12 text-center">
                    <div className="row">
                        <div className="offset-2 col-8">
                            <h1 className="mb-4">Would you like to submit additional photos of pre-condition details that aren't visible in your other submitted photos?</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-2 col-8">
                            <div className="mb-3">
                                <button type="button" className={"base-input white-green mb-4"} onClick={this.yes.bind(this)}>
                                    YES
                                </button>
                                <button type="button" className={"base-input white-red mb-4"} onClick={this.no.bind(this)}>
                                    NO
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class ShowPopupVerifyingPhoto extends Component {
    constructor(props) {
        super(props);
    }

    goBack() {
        close_popup();
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 py-4 text-center">
                    <span className="loader-verifying"><span className="loader-verifying-inner" /></span>
                    <span className="ml-3">Verifying photo...</span>
                </div>
            </div>
        )
    }
}

class UploadLicensePopup extends Component {
    constructor(props) {
        super(props);
    }

    goBack() {
        close_popup();
    }

    sendPhoto(e) {
        this.props.sendPhoto(e)
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="row mx-3 my-2">
                        <div className="col-12 text-center">
                            <p>Upload image of your e-license here</p>
                        </div>
                    </div>
                    <div className="row mx-3 mb-2">
                        <input type="file" id="photo_upload" accept="image/*"
                               className="form-control mb-4" name="photo"
                               onClick={()=>{device_inform(false); return true;}}
                               onChange={this.sendPhoto.bind(this)}/>
                        <label htmlFor="photo_upload"
                               className="base-input">UPLOAD FILE</label>
                    </div>
                    <div className="row mx-3 mb-3">
                        <div className="go-btn go-back mx-auto" onClick={this.goBack.bind(this)} />
                    </div>
                </div>
            </div>
        )
    }
}

const phAdditSteps = {
    max: 5,
    photos: [
        'additional_photo1',
        'additional_photo2',
        'additional_photo3',
        'additional_photo4',
        'additional_photo5'
    ]
};

class SendPhotoPage extends Component {

    run = true;

    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.sendPhoto = this.sendPhoto.bind(this);
        this.handleSetPage({name: 'send_photo', params: false});
        this.nextSubPage = this.nextSubPage.bind(this);
        this.titleOfStep = this.titleOfStep.bind(this);
        this.switchToStep = this.switchToStep.bind(this);
        this.setStep = this.setStep.bind(this);
        this.getPhotos = this.getPhotos.bind(this);

        this.showAdditPhotosBlock = this.showAdditPhotosBlock.bind(this);
        this.addAdditPhoto = this.addAdditPhoto.bind(this);
        this.sortAdditPhotos = this.sortAdditPhotos.bind(this);
        this.updateMaxPhotosByStack = this.updateMaxPhotosByStack.bind(this);
        this.state = {
            step: 'selfie',
            completed: false,
            redirect: null,
            operation: '',
            uploadPercent: 0,
            currentMaxAdditPhoto: 1,
            stackAdditPhotoUnlock: [],
            isShowAdditPhotoBlock: false
        };

        if (['lock', 'unlock'].indexOf(this.props.match.params.operation) === -1 || this.props.match.params.operation !== this.props.global_operation) {
            this.run = false;
        } else {
            this.state.operation = this.props.match.params.operation;
        }

        // if (Object.keys(this.state.file_urls).indexOf(this.state.step) === -1  || !this.state.file_urls[this.state.step]) {
        //     this.state.redirect = 'welcome';
        // }
        this.isRun(true);

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    componentDidMount() {
        this.sortAdditPhotos();
        this.updateMaxPhotosByStack();
        if (!!this.state.stackAdditPhotoUnlock.length) {
            this.setState({isShowAdditPhotoBlock: true});
        }

        let photo_param = this.props.match.params.photo;
        if (!steps[this.state.operation] || !steps[this.state.operation][photo_param]) {
            if (this.state.operation === 'unlock') {
                if (photo_param > -1  && photo_param < 5) {
                    photo_param = parseInt(photo_param);
                    this.setState({step: photo_param, currentMaxAdditPhoto: photo_param+1, isShowAdditPhotoBlock: true})
                } else
                    this.run = false;
            } else
                this.run = false;
        } else {
            this.setState({step: this.props.match.params.photo});
        }

        this.isRun();

        this.unlisten = this.props.history.listen((location, action) => {
            if (location.pathname !== '/vehicle_state' && location.pathname !== '/turn_off_lights') {
                setUrlSinglePageApp(location.pathname);
            }
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    isRun(isConstr) {
        /*console.log('constr');
        console.log(isConstr);
        console.log(this.run);
        return;*/
        if (!this.run) {
            if (isConstr)
                this.state.redirect = 'welcome';
            else
                this.setState({redirect: 'welcome'});
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.photo !== this.props.match.params.photo) {
            this.setState({step: this.props.match.params.photo})
        }
    }

    handleSetPage(options) {
        if (options.name == 'send_photo')
            addStepLog('Send photo Page on '+this.props.global_operation+' operation');
        this.props.handleSetPage(options);
    }

    getPhotos(item) {
        if (item)
            return this.props.files[this.state.operation][item];
        else
            return this.props.files[this.state.operation]
    }

    sendPhoto(step, e) {
        addStepLog('Send photo, step: '+step+' on Send photo Page on '+this.props.global_operation+' operation');

        let t = this;
        let file = e.target.files[0];

        compressImage(
            file,
            (modifiedFile) => {
            let params = {
                session_key: t.props.session_key,
                resno: t.props.client_data.resno,
                operation: t.props.global_operation,
                global_operation: t.props.global_operation,
                step: step,
                files: {
                    photo: modifiedFile
                },
                action: 'api/booking/send_photo'
            };

            AJAX(bm_ajax_url, 'POST', params, {
                response_json: true,
                func_waiting: ()=>showProgressBarPopup(t.state.uploadPercent),
                func_callback: function (resp) {
                    console.log(JSON.stringify(resp));
                    close_popup();
                    if (resp.success === 1 && Object.keys(resp.data).length) {
                        // let files = resp.data.files;
                        t.props.handleSetBookingState(resp.data.booking_state);
                        t.setState({uploadPercent: 0});
                        if (t.state.operation === 'unlock' && ['selfie', 'license'].indexOf(t.state.step) !== -1) {
                            show_popup(<ShowPopupVerifyingPhoto />, {auto_close: false});
                            setTimeout(()=>close_popup(), 3000);
                        }
                        /*if (t.state.operation === 'unlock' && t.state.step === 'front' && !t.state.isShowAdditPhotoBlock) {
                            show_popup(<ShowPopupQuestionAboutAdditPhoto yes={()=>{t.setState({isShowAdditPhotoBlock: true})}} no={t.nextSubPage}/>, {auto_close: false});
                        } else {
                            t.nextSubPage();
                        }*/
                        t.sortAdditPhotos();
                        t.nextSubPage(true);
                        if (t.state.step !== 'complete') {
                            setTimeout(() => {
                                let element = document.getElementById(t.state.step + '_block');
                                if (element) {
                                    element.scrollIntoView({block: "center", behavior: "smooth"});
                                }
                            }, 250);
                        }
                    } else {
                        if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                            showPopupWithGoBack(resp.errors.main);
                        }
                    }
                },
                func_error: function (resp) {
                    console.log(JSON.stringify(resp));
                    close_popup();
                    // show_error_popup(resp.message);
                    showPopupWithGoBack(resp.message);
                },
                func_progress: function (evt) {
                    if (evt.lengthComputable) {
                        let percentComplete = Math.round(evt.loaded / evt.total * 100);
                        t.setState({uploadPercent: percentComplete}, () => showProgressBarPopup(t.state.uploadPercent));
                    }
                }
            });
        });
    }

    nextSubPage(isAjax) {
        addStepLog('Press button GoNext on Send Photo Page')

        let t = this;
        let redirect = 'vehicle_state';
        if (typeof steps[t.state.operation][t.state.step] !== 'undefined') {
            let next_step = steps[t.state.operation][t.state.step].next;
            if (next_step === 'complete') {
                let photos = t.getPhotos();
                let list_photo_keys = Object.keys(steps[t.state.operation]);
                let lack_photos = [];
                for (let i in list_photo_keys) {
                    if (!photos[list_photo_keys[i]])
                        lack_photos.push(list_photo_keys[i]);
                }
                if (!lack_photos.length) {
                    if (t.state.operation === 'lock') {
                        redirect = 'turn_off_lights';
                    }
                    function redirectToNextPage() {
                        t.setState({redirect: redirect});
                        $('.page-with-header.page-with-banner').animate({scrollTop: 0}, 250);
                    }
                    if (t.state.operation === 'unlock') {
                        if(!t.state.isShowAdditPhotoBlock) {
                            show_popup(<ShowPopupQuestionAboutAdditPhoto yes={()=>{t.setState({isShowAdditPhotoBlock: true}); t.setStep(0)}} no={redirectToNextPage}/>, {auto_close: false});
                        } else {
                            t.setStep(0);
                        }
                    } else {
                        redirectToNextPage();
                    }
                } else {
                    // let list_no_photo = list_photo_keys.filter(n => list_files_keys.indexOf(n) === -1);
                    t.setStep(lack_photos[0]);
                }
            } else {
                t.setStep(next_step);
            }
        } else if(t.state.operation === 'unlock' && t.state.isShowAdditPhotoBlock) {
            if (!isAjax) {
                let s = parseInt(t.state.step);
                if (s < t.state.currentMaxAdditPhoto - 1) {
                    t.setStep(s + 1);
                } else {
                    t.setState({redirect: redirect});
                }
            }
        }
    }

    showPopupExamplePhoto() {
        return <>&nbsp;(<a className="blue-link" onClick={(event => {event.preventDefault(); show_popup(<ShowPopupExampleSelfie />, {auto_close:false});})}>show example image</a>)</>;
    }

    titleOfStep(step) {
        let preview_texts = {
            selfie: (<div><Link to={'/send_photo/'+this.state.operation+'/selfie'} className="blue-link">Selfie</Link>&nbsp;picture</div>),
            driver: (<div><Link to={'/send_photo/'+this.state.operation+'/driver'} className="blue-link">Driver's</Link>&nbsp;side of the vehicle</div>),
            passenger: (<div><Link to={'/send_photo/'+this.state.operation+'/passenger'} className="blue-link">Passenger</Link>&nbsp;side of the vehicle</div>),
            front: (<div><Link to={'/send_photo/'+this.state.operation+'/front'} className="blue-link">Front</Link>&nbsp;of the vehicle</div>),
            rear: (<div><Link to={'/send_photo/'+this.state.operation+'/rear'} className="blue-link">Rear</Link>&nbsp;of vehicle</div>),
            dashboard: (<div><Link to={'/send_photo/'+this.state.operation+'/dashboard'} className="blue-link">Dashboard and Fuel</Link>&nbsp;</div>),
            license: (<div><Link to={'/send_photo/'+this.state.operation+'/license'} className="blue-link">License</Link>&nbsp;picture</div>),
            cargo: (<div><Link to={'/send_photo/'+this.state.operation+'/cargo'} className="blue-link">Cargo area</Link>&nbsp;of the vehicle</div>),
        };
        return preview_texts[step];
    }

    switchToStep(step){
        if (steps[this.operation] && steps[this.operation][step]) {
            this.setStep(step);
        }
    }

    setStep(step) {
        this.setState({step: step});
        this.props.history.push('/send_photo/' + this.state.operation + '/' + step);
    }

    showTakePhotoButton(step) {
        return (
        <div className="row photo-btns-block">
            <div className="offset-2 col-8 text-center">
                <div className="form-group mb-4">
                    <div id="photo_errors"/>
                    <input type="file" id="photo" accept="image/*" capture="camera"
                           className="form-control mb-4" name="photo"
                           onClick={()=>{addStepLog('Click button TAKE/REPLACE PHOTO, step: '+step+' on Send photo Page on '+this.props.global_operation+' operation'); device_inform('license' === step); return true;}}
                           onChange={this.sendPhoto.bind(this, step)}/>
                    <label htmlFor="photo"
                           className="base-input">{!this.getPhotos(step) ? "TAKE PHOTO" : "REPLACE PHOTO"}</label>

                    {
                        /*(this.state.operation === 'unlock' && this.state.step === 'license') ? (<>
                            <input type="file" id="photo_upload" accept="image/!*"
                                   className="form-control mb-4" name="photo"
                                   onChange={this.sendPhoto.bind(this, this.state.step)}/>
                            <label htmlFor="photo_upload"
                                   className="base-input">UPLOAD FILE</label>
                        </>) : ('')*/
                        (this.state.operation === 'unlock' && this.state.step === 'license') ? (<p>
                            Have a new e-license?<br/>Click <a className="blue-link" onClick={event => {event.preventDefault(); show_popup(<UploadLicensePopup sendPhoto={event=>this.sendPhoto(this.state.step, event)}/>, {auto_close:false})}}>here</a>
                        </p>) : ('')
                    }
                </div>
            </div>
        </div>
        );
    }

    sortAdditPhotos() {
        let t = this;
        let files = t.props.files[t.state.operation];
        let stackAdditPhoto = t.state.stackAdditPhotoUnlock;
        for(let i in files) {
            if (phAdditSteps.photos.indexOf(i) !== -1) {
                let indexInStack = stackAdditPhoto.indexOf(i);
                if (files[i]) {
                    if (indexInStack === -1)
                        stackAdditPhoto.push(i);
                } else {
                    if (indexInStack !== -1) {
                        stackAdditPhoto.splice(indexInStack, 1);
                    }
                }
            }
        }
        t.setState({stackAdditPhotoUnlock: stackAdditPhoto})
    }

    updateMaxPhotosByStack() {
        let lStack = this.state.stackAdditPhotoUnlock.length;
        let lMaxPhoto = phAdditSteps.photos.length;
        let currMax = 1;
        if (lStack > 0 && lStack <= lMaxPhoto) {
            currMax = lStack;
        } else if (lStack > lMaxPhoto) {
            currMax = lStack;
        }
        let step = this.state.step;
        if (this.state.operation === 'unlock' && this.state.completed) {
            step = currMax-1
        }

        this.setState({currentMaxAdditPhoto: currMax, step: step});

    }

    addAdditPhoto(event) {
        event.preventDefault();
        let currMax = this.state.currentMaxAdditPhoto;
        let lMaxPhoto = 5;
        if (currMax < lMaxPhoto) {
            currMax++;
            this.setState({currentMaxAdditPhoto: currMax});
            this.setStep(currMax-1);
        }
    }

    getRealPhotos(step) {
        let photo = this.props.files[this.state.operation][step];
        if (photo)
            return photo;
        return null;
    }

    removePhoto(currPhoto) {
        let params = {
            session_key: this.props.session_key,
            resno: this.props.client_data.resno,
            operation: 'unlock',
            global_operation: this.props.global_operation,
            step: currPhoto,
            action: 'api/booking/remove_photo'
        };
        let t = this;

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    t.props.handleSetBookingState(resp.data.booking_state);
                    if (t.state.currentMaxAdditPhoto > 1) {
                        let updMax = t.state.currentMaxAdditPhoto-1;
                        let updCurrStep = t.state.step;
                        if (updCurrStep >= updMax)
                            updCurrStep = updMax - 1;

                        t.setState({currentMaxAdditPhoto: updMax, step: updCurrStep});
                    }
                    t.sortAdditPhotos();
                } else {
                    hidePreloader();
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            },
        });
    }

    showAdditPhotosBlock() {
        let max_ph = this.state.currentMaxAdditPhoto;

        let currentStack = this.state.stackAdditPhotoUnlock.slice();
        let currentStackWithEmpty = currentStack.slice();
        if (currentStackWithEmpty.length < phAdditSteps.photos.length) {
            for (let i in phAdditSteps.photos) {
                if (currentStackWithEmpty.indexOf(phAdditSteps.photos[i]) === -1) {
                    currentStackWithEmpty.push(phAdditSteps.photos[i]);
                }
            }
        }

        let previews = [];

        for (let i = 0; i < max_ph; i++) {
            let currentPhoto = currentStackWithEmpty[i];
            let realPh = this.getRealPhotos(currentPhoto);
            previews.push(
                <div id={i + '_block'} key={i}>
                    <div className={"photo-preview" + (this.state.step == i ? ' current_step' : '')}>
                        {
                            realPh ? (
                                <PreviewPhoto src={realPh} />
                            ) : (
                                <div className="no-photo"/>
                            )
                        }
                        <div>Additional <a className="blue-link" onClick={event => {event.preventDefault(); this.setStep(i)}}>photo {i+1}</a></div>
                        {
                            realPh ? (
                                <div className="remove-photo" onClick={()=>this.removePhoto(currentPhoto)}>
                                    <div />
                                    <div />
                                </div>
                            ) : ('')
                        }
                    </div>
                    {
                        this.state.step == i && this.state.currentMaxAdditPhoto < phAdditSteps.max && this.state.currentMaxAdditPhoto === currentStack.length ? (
                            <div className="row">
                                <div className="offset-2 col-8 text-center mb-4">
                                    <label className="base-input" onClick={this.addAdditPhoto}>ADD PHOTO</label>
                                </div>
                            </div>
                        ) : ('')
                    }
                    {
                        this.state.step == i && !this.getPhotos(currentPhoto) ? this.showTakePhotoButton(currentPhoto) : ('')
                    }
                </div>
            )
        }
        return previews;
    }

    render() {
        let text;
        if (!this.state.completed) {
            switch (this.state.step) {
                case 'driver':
                    text = 'Please take a photo of the driver\'s side of the vehicle';
                    break;
                case 'license':
                    text = 'Please take a photo of your driver\'s license';
                    break;
                case 'passenger':
                    text = 'Please take a photo of the Passenger side of the vehicle';
                    break;
                case 'front':
                    text = 'Please take a photo of the front of vehicle';
                    break;
                case 'selfie':
                    text = 'Please make sure the selfie picture is of the main hirer and the hire vehicle is shown in the background.';
                    break;
                case 'rear':
                    text = 'Please take a photo of the Rear of vehicle';
                    break;
                case 'dashboard':
                    text = 'Please take a photo of the dashboard and fuel showing the odometer reading at drop off';
                    break;
                case 'cargo':
                    text = 'Please take a photo of the cargo area to show the condition at dropoff.';
                    break;
            }
        }

        let previews = [];
        let concrete_steps = steps[this.state.operation];
        for (let item in concrete_steps) {
            previews.push(
                (<div id={item + '_block'} key={item}>
                    <div className={"photo-preview" + (this.state.step === item ? ' current_step' : '')} key={item}>
                        {
                            this.getPhotos(item) ? (
                                <PreviewPhoto src={this.getPhotos(item)} text={this.titleOfStep(item)}/>
                            ) : (
                                <><div className="no-photo"/>{this.titleOfStep(item)}</>
                            )
                        }
                    </div>
                    {
                        item === this.state.step ? (<>
                            <TextContent content={(<div className="mx-2 mt-2">
                                <p>{text}{this.state.step==='selfie' ? this.showPopupExamplePhoto() :''}</p>
                            </div>)}/>
                            {this.showTakePhotoButton(item)}
                            </>
                        ) : ('')
                    }
                </div>
                )
            );
            if (!this.getPhotos(item))
                break;
        }

        if (this.state.redirect !== null) {
            return <Redirect push to={'/' + this.state.redirect}/>;
        }

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-1 col-10">
                        {
                            this.state.operation === 'unlock' ? (
                                <h1 className="my-4">We require photos for hirer verification and security before you can unlock your vehicle (<span style={{color:"#d63545", fontSize:"16px", fontWeight: "600"}}>{this.props.vehicle_data.RegistrationNo}</span>).</h1>
                            ) : (
                                <h1 className="my-4">We require you to take 6 x Photos to confirm the condition of the
                                    vehicle at drop off. This process assists you against any wrongful claim of
                                    damage.</h1>
                            )
                        }
                    </div>
                </div>

                {
                    previews.length ? (
                        <div className="row">
                            <div className="col-12 mx-4 pl-4 pr-5 text-left">
                                {previews}
                            </div>
                        </div>
                    ) : ('')
                }
                {
                    this.state.isShowAdditPhotoBlock ? (
                        <>
                        <div className="row mt-3">
                            <div className="offset-2 col-8 text-center">
                                <h2 className="gray">Additional photos (up to 5)</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 mx-4 pl-4 pr-5 text-left">
                                {

                                    this.showAdditPhotosBlock()
                                }
                            </div>
                        </div>
                        </>) : ('')
                }
                {
                    this.state.completed ? ('') : (
                        <>
                            <div className="row">
                                <div className="offset-2 col-8 text-center">
                                    <div className="form-group mb-4">
                                        {
                                            this.getPhotos(this.state.step) || this.state.isShowAdditPhotoBlock ? (
                                                <div className="go-btn go-next mx-auto" onClick={() => this.nextSubPage()} />
                                            ) : ('')
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        </>);
    }
}

const SendPhotoPageR = withRouter(SendPhotoPage);
export default SendPhotoPageR;
